import { createSlice } from '@reduxjs/toolkit'
import { DEFAULT_GLOBAL_ALERT_STATE, GLOBAL_STATE_NAME } from '../constants'

export const globalAlertSlice = createSlice({
  name: GLOBAL_STATE_NAME.ALERT,
  initialState: DEFAULT_GLOBAL_ALERT_STATE,
  reducers: {
    createAlertMessage: (state, action) => {
      const { level, title, description } = action.payload || {}
      state.level = level
      state.title = title
      state.description = description
    },
    clearAlertMessage: () => DEFAULT_GLOBAL_ALERT_STATE,
  },
})

export const globalAlertActions = globalAlertSlice.actions

export const selectGlobalAlert = (state) => state[globalAlertSlice.name]
